import React from 'react';

import SafeImage from '../../../elements/SafeImage';
import styles from './Location.module.scss';

const Location = props => {
    const {event, location} = props;

    return (
        <div className={styles.Location}>
            <h3>{location.name}</h3>
            <hr style={{borderColor: event.settings.primary_color}} />
            <SafeImage className={styles.image} src={location.image_url} />
        </div>
    );
};

export default Location;
